import { SelectOption } from '@/shared/types';

import { FileType } from '@/helpers/fileHelper';

import { SERVICE_CODES } from '@/lib/consts';

export const SERVICE_CODE = SERVICE_CODES.MISSING_PERSON;

export enum MissingPersonStatus {
  civil = 'civil',
  military = 'military',
}

export const MISSING_PERSON_STATUS_OPTIONS: Array<SelectOption<MissingPersonStatus>> = [
  {
    id: MissingPersonStatus.civil,
    label: 'Цивільний',
  },
  {
    id: MissingPersonStatus.military,
    label: 'Військовий',
  },
];

export const YesNoSelectOptions = {
  YES: {
    id: '1',
    label: 'Так',
  },
  NO: {
    id: '0',
    label: 'Ні',
  },
} as const;

export enum DnaMethod {
  biologicalSamples = 'biologicalSamples',
  personalItems = 'personalItems',
  relativeItems = 'relativeItems',
}

export const DnaMethodMapping = {
  [DnaMethod.biologicalSamples]: 'Біологічні зразки',
  [DnaMethod.personalItems]: 'Особисті речі особи зниклої безвісти',
  [DnaMethod.relativeItems]: 'Особисті речі родича особи зниклої безвісти',
};

export const DnaMethodOptions: SelectOption[] = [
  {
    id: DnaMethod.biologicalSamples,
    label: DnaMethodMapping[DnaMethod.biologicalSamples],
  },
  {
    id: DnaMethod.personalItems,
    label: DnaMethodMapping[DnaMethod.personalItems],
  },
  {
    id: DnaMethod.relativeItems,
    label: DnaMethodMapping[DnaMethod.relativeItems],
  },
];
export const OTHER_ANCESTRAL_CONNECTION_ID = '25';

export const missingPersonAllowedFileTypes = [
  FileType.JPEG,
  FileType.PNG,
  FileType.SVG,
  FileType.HEIF,
  FileType.HEIC,
  FileType.PDF,
];

export const HEIGHT_REGEXP = /^\d+(?:[,]\d{1,2})?$/;
